<template lang="pug">
v-dialog(
  v-model="dialog"
  :nudge-right="40"
  :nudge-width="200"
  transition="scale-transition"
  offset-y
  width="290px"
)
  template(v-slot:activator="{ on }")
    v-text-field(
      :value="time"
      :label="label"
      prepend-inner-icon="mdi-clock-time-five"
      readonly
      v-on="{...on, ...$listeners}"
      required
      v-bind="$attrs"
    )
  v-time-picker(
    locale="ru-ru"
    v-model="time"
    format="24hr"
    :min="min"
    :max="max"
    scrollable
  )
    v-btn.flex-grow-1(color="primary", @click="dialog = false") Сохранить
    v-btn.flex-grow-1(@click="dialog = false") Отменить

</template>

<script>
export default {
  props: {
    value:  { type: String, default: '' },
    label:  { type: String, default: 'Время' },
    min:    { type: String, default: '' },
    max:    { type: String, default: '' },
  },
  data() {
    return {
      dialog:false,
    };
  },
  computed: {
    time: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
